const CARDS = [
  {
    id: 1,
    title: '《重生之都市修仙》',
    desc: '一代仙尊重生都市，逆天改命再踏仙途。燃爆全网的国漫热血力作，下拉式阅读体验极佳。',
    tag: '国漫·热血',
    tagColor: 'bg-red-50 text-red-600',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20style%20illustration%20of%20a%20cultivator%20in%20modern%20city%20with%20spiritual%20energy%20effects%20martial%20arts%20pose%20and%20dramatic%20lighting%20warm%20orange%20and%20coral%20tones%20clean%20cream%20background%20highly%20stylized&width=600&height=400&seq=card-comic-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《霸道总裁的契约新娘》',
    desc: '韩漫恋爱天花板，契约婚姻暗生情愫。超甜剧情搭配细腻画风，收藏追更人数持续飙升。',
    tag: '韩漫·恋爱',
    tagColor: 'bg-pink-50 text-pink-600',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20style%20illustration%20of%20elegant%20couple%20in%20modern%20setting%20with%20soft%20pastel%20warm%20lighting%20floral%20elements%20gentle%20atmosphere%20clean%20cream%20background%20highly%20stylized&width=600&height=400&seq=card-comic-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《咒术回战·外传》',
    desc: '日漫人气IP衍生外传，咒术师与诅咒的惊险对决。下拉式阅读还原原版漫画节奏感。',
    tag: '日漫·战斗',
    tagColor: 'bg-amber-50 text-amber-600',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20action%20illustration%20with%20supernatural%20warrior%20using%20magic%20powers%20dramatic%20dynamic%20pose%20speed%20lines%20dark%20ink%20accents%20warm%20lighting%20clean%20cream%20background%20highly%20stylized&width=600&height=400&seq=card-comic-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《我在诡异世界当NPC》',
    desc: '恐怖悬疑国漫新秀，诡异世界设定脑洞大开。全集免费连载中，下拉式阅读沉浸感满分。',
    tag: '国漫·悬疑',
    tagColor: 'bg-purple-50 text-purple-600',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20horror%20mystery%20manhua%20style%20illustration%20with%20dark%20atmospheric%20scene%20shadowy%20figures%20foggy%20environment%20subtle%20warm%20orange%20accents%20tense%20mood%20clean%20composition%20highly%20stylized&width=600&height=400&seq=card-comic-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《剑与魔法学院》',
    desc: '日漫校园奇幻经典，剑术与魔法的青春物语。韩漫日漫爱好者口碑推荐，连载追更不容错过。',
    tag: '日漫·奇幻',
    tagColor: 'bg-teal-50 text-teal-600',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20fantasy%20manga%20style%20illustration%20of%20magic%20academy%20students%20with%20swords%20and%20magic%20spells%20vibrant%20colorful%20atmosphere%20warm%20lighting%20clean%20cream%20background%20highly%20stylized%20artistic&width=600&height=400&seq=card-comic-05&orientation=landscape',
  },
  {
    id: 6,
    title: '《财阀家的小儿子》',
    desc: '韩漫穿越重生经典之作，财阀家族恩怨与商战风云。下拉式条漫阅读体验，全集一次性追完。',
    tag: '韩漫·重生',
    tagColor: 'bg-indigo-50 text-indigo-600',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20illustration%20of%20business%20drama%20with%20elegant%20characters%20in%20luxury%20setting%20corporate%20atmosphere%20warm%20amber%20lighting%20clean%20cream%20background%20highly%20stylized%20artistic&width=600&height=400&seq=card-comic-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            编辑部精选六部优质漫画，韩漫日漫国漫全覆盖，下拉式阅读即刻开启
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARDS.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block text-xs font-medium px-2 py-0.5 rounded-full ${card.tagColor} mb-2`}>
                  {card.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}